export const PAYMENT_TRANSACTIONS_RESET_STATE = 'PAYMENT_TRANSACTIONS_RESET_STATE';
export const PAYMENT_TRANSACTIONS_CURRENT_ITEM = 'PAYMENT_TRANSACTIONS_CURRENT_ITEM';

export const PAYMENT_TRANSACTIONS_REQUEST_LOADING = 'PAYMENT_TRANSACTIONS_REQUEST_LOADING';
export const PAYMENT_TRANSACTIONS_REQUEST_SUCCESS = 'PAYMENT_TRANSACTIONS_REQUEST_SUCCESS';
export const PAYMENT_TRANSACTIONS_REQUEST_FAILED = 'PAYMENT_TRANSACTIONS_REQUEST_FAILED';

export const PAYMENT_TRANSACTIONS_CURRENT_ACTION = 'PAYMENT_TRANSACTIONS_CURRENT_ACTION';
export const PAYMENT_TRANSACTIONS_RESET_ACTION = 'PAYMENT_TRANSACTIONS_RESET_ACTION';